










import { defineComponent } from '@vue/composition-api';
import ALink from '@/components/common/a-link/a-link.vue';

const name = 'ttam-promotion-app-ios14-tips';
export default defineComponent({
  name,
  components: { ALink },
  props: {
    href: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {};
  },
});
